// extracted by mini-css-extract-plugin
export default {"auth":"App_auth__IyQzy"};